import React from 'react'
import styles from "./aboutusSec.module.css";
import useTextAnimation from '../../hooks/useTextAnimation';
import { motion } from 'framer-motion';
import { abtOurClent1, abtOurClent2, abtOurClent3, abtOurClent4, abtOurClent5, abtOurClent6, abtOurClent7, abtOurClent8, abtOurClent9, abtOurClent10, abtOurClent11, abtOurClent12, abtOurClent13, abtOurClent14, abtOurClent15, abtOurClent16, abtOurClent17, abtOurClent18, abtOurClent19, abtOurClent20, abtOurClent21, abtOurClent22, abtOurClent23, abtOurClent24, abtOurClent25, abtOurClent26, }
    from '../../../assets';
import { IMAGE_URL } from '../../helpers/api_helper';
import { useTranslation } from 'react-i18next';
import { LANG_AR } from '../../helpers/constant';

const AboutOurClients = ({clientData}) => {
    const [t,i18n]= useTranslation()
    const clientsImg = [
        abtOurClent1,
        abtOurClent2,
        abtOurClent3,
        abtOurClent4,
        abtOurClent5,
        abtOurClent6,
        abtOurClent7,
        abtOurClent8,
        abtOurClent9,
        abtOurClent10,
        abtOurClent11,
        abtOurClent12,
        abtOurClent13,
        abtOurClent14,
        abtOurClent15,
        abtOurClent16,
        abtOurClent17,
        abtOurClent18,
        abtOurClent19,
        abtOurClent20,
        abtOurClent21,
        abtOurClent22,
        abtOurClent23,
    ]

    return (
        <div className={styles.ourClients}>
            <div className={styles.ourClients_inner}>
                <div className={`${styles.ourClients_title} ${i18n.language===LANG_AR? 'arabCenter':''}`}>
                    <h3>{t('aboutOurClients')}</h3>
                </div>
            </div>
            <div className={styles.ourClients_clientLists}>
                {/* <div className={styles.ourClients_clientListInner}>
                    <ul className={styles.ourClients_clientList}>
                        {clientsImg.map((clientImg, index) => (
                            <li key={index}>
                                <img src={clientImg} alt="" />
                            </li>
                        ))}
                    </ul>
                </div> */}


                <div className={styles.ourClients_clientListInner}>
                    <ul className={styles.ourClients_clientList}>
                        {(clientData || []).map((client, index) => (
                            <li key={index}>
                                <img src={`${IMAGE_URL}/clients/${client.image}`} alt={`Slide ${index + 1}`} loading='lazy' />
                            </li>
                        ))}     
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default AboutOurClients
